import { render } from "./BinanceAlpha.vue?vue&type=template&id=23189b10"
import script from "./BinanceAlpha.vue?vue&type=script&lang=js"
export * from "./BinanceAlpha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__